import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiX, FiBriefcase, FiArrowRight } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => setIsOpen(false), [location]);

  const navLinks = [
    { name: 'Für Bewerber', path: '/bewerber' },
    { name: 'Für Unternehmen', path: '/unternehmen' },
    { name: 'Jobbereiche', path: '/jobbereiche' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${
      scrolled 
        ? 'bg-white/80 backdrop-blur-lg shadow-sm py-3' 
        : 'bg-transparent py-6'
    }`}>
      <div className="container-custom">
        <div className="flex justify-between items-center">
          
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-teal-600/30 group-hover:rotate-6 transition-transform">
              <SafeIcon icon={FiBriefcase} className="text-xl" />
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-900">
              Nebenjob<span className="text-teal-600">Nord</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <div className="flex gap-7">
              {navLinks.map((link) => (
                <Link 
                  key={link.name} 
                  to={link.path}
                  className={`text-[15px] font-semibold transition-all hover:text-teal-600 relative py-2 ${
                    location.pathname === link.path ? 'text-teal-600' : 'text-slate-600'
                  }`}
                >
                  {link.name}
                  {location.pathname === link.path && (
                    <motion.div layoutId="navunderline" className="absolute bottom-0 left-0 w-full h-0.5 bg-teal-600 rounded-full" />
                  )}
                </Link>
              ))}
            </div>
            
            <div className="flex items-center gap-4">
              <Link to="/unternehmen" className="btn-primary !py-2.5 !px-6 !text-sm">
                Personal anfragen
              </Link>
            </div>
          </div>

          {/* Mobile Toggle */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-slate-600">
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-slate-100 overflow-hidden"
          >
            <div className="container-custom py-8 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link 
                  key={link.name} 
                  to={link.path} 
                  className="text-lg font-bold text-slate-900 hover:text-teal-600"
                >
                  {link.name}
                </Link>
              ))}
              <hr className="border-slate-100 my-2" />
              <Link to="/bewerber" className="btn-outline w-full">Job suchen</Link>
              <Link to="/unternehmen" className="btn-primary w-full">Personal anfragen</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;